import React from 'react';
import PostSkeleton from './PostSkeleton';

const FeedSkeleton = ({ count = 2, isDarkMode }) => {
  return (
    <div className={`feed-skeleton ${isDarkMode ? 'dark' : 'light'}`}>
      {Array.from({ length: count }, (_, index) => (
        <PostSkeleton key={index} isDarkMode={isDarkMode} />
      ))}
    </div>
  );
};

export default FeedSkeleton;
